import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconStopStyle0 = gravityIconIndividualCss;

const GravityIconStop = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '1df73b1587c4e94f957304d42037dc338dfdd0e2', color: this.color, size: this.size }, h("svg", { key: 'ac24bc1b6527326495caf43d9834db994f0630d5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '5ccadb40649520c52e52c82b441800df958ec4a5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconStop.style = GravityIconStopStyle0;

export { GravityIconStop as gravity_icon_stop };

//# sourceMappingURL=gravity-icon-stop.entry.js.map